//   Generated by Paratype Generator

import { Injectable } from '@angular/core';
import { BaseServiceV2 } from '@common/service/base.service-v2';
import { EmployeeDTO } from '@gen/employee/employee.dto';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService extends BaseServiceV2<EmployeeDTO> {
  override entityUrl = 'employee';
  override entityName = 'Employee';
}
